module.exports = __webpack_public_path__ + "static/media/01-galeria-06-gucci-mobile@2x.c7646e23.jpg";